@if (store.resumeCandidate) {
  <div class="admin-import-module__section">
    <mat-card appearance="outlined" class="admin-import-module__resume">
      <mat-card-content>
        <mat-icon>restore</mat-icon>
        <span>{{ 'TRANS__IMPORT__RESUME__QUESTION' | translate: {fileName: store.resumeCandidate.fileName} }}</span>
        <button
          mat-stroked-button
          type="button"
          color="primary"
          [disabled]="store.resumingSession || store.uploading"
          (click)="store.resumeSession()"
        >
          {{ 'TRANS__IMPORT__RESUME__CONFIRM' | translate }}
        </button>
        @if (store.resumingSession) {
          <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
        }
        <button mat-button type="button" [disabled]="store.resumingSession" (click)="store.dismissResumeCandidate()">
          {{ 'TRANS__IMPORT__RESUME__DISMISS' | translate }}
        </button>
      </mat-card-content>
    </mat-card>
  </div>
}

<div class="admin-import-module__kilde">
  <div class="admin-import-module__section admin-import-module__section--column admin-import-module__section--file" id="import-source-file">
    <h4>{{ 'TRANS__IMPORT__FILE_SECTION' | translate }}</h4>
    <mat-card appearance="outlined">
      <mat-card-content>
        <p class="admin-import-module__hint">{{ 'TRANS__IMPORT__FILE_HINT' | translate }}</p>
        <div class="admin-import-module__file">
          <input
            #fileInput
            type="file"
            hidden
            [accept]="acceptedExtensions"
            (change)="onFileSelected($event)"
          >
          @if (store.fileName && !store.uploading) {
            <mat-icon class="admin-import-module__file-icon">description</mat-icon>
            <span class="admin-import-module__file-name">
              <span class="bold">{{ store.fileName }}</span>
              @if (fileFacts.length || store.tables.length) {
                <span class="admin-import-module__file-meta">
                  @for (fact of fileFacts; track $index) {
                    @if (!$first) {
                      ·
                    }
                    {{ fact }}
                  }
                  @if (store.tables.length) {
                    @if (fileFacts.length) {
                      ·
                    }
                    {{ 'TRANS__IMPORT__FILE_TABLE_COUNT' | translate: {count: store.tables.length} }}
                  }
                </span>
              }
            </span>
          }
          @if (store.uploading) {
            <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
          }
          <button
            mat-stroked-button
            type="button"
            color="primary"
            [disabled]="store.uploading || store.resumingSession"
            (click)="fileInput.click()"
          >
            <i class="icon-upload"></i>
            <span class="bold uppercase">
              {{ (store.fileName ? 'TRANS__IMPORT__CHANGE_FILE' : 'TRANS__IMPORT__CHOOSE_FILE') | translate }}
            </span>
          </button>
          @if (store.fileName && !store.uploading) {
            <button
              mat-icon-button
              type="button"
              [attr.aria-label]="'TRANS__IMPORT__CLEAR_FILE' | translate"
              [matTooltip]="'TRANS__IMPORT__CLEAR_FILE' | translate"
              (click)="store.clearFile()"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
        @if (store.previousFileGone) {
          <p class="admin-import-module__warn">{{ 'TRANS__IMPORT__RESUME__FILE_GONE' | translate }}</p>
        }
        @if (store.uploadError) {
          <span class="admin-import-module__error">{{ store.uploadError | translate }}</span>
        }
      </mat-card-content>
    </mat-card>
  </div>

  <div class="admin-import-module__section admin-import-module__section--wide admin-import-module__section--table" id="import-source-table">
    <h4>{{ 'TRANS__IMPORT__TABLE_SECTION' | translate }}</h4>
    <mat-card appearance="outlined">
      <mat-card-content>
        <p class="admin-import-module__hint">{{ 'TRANS__IMPORT__TABLE_HINT' | translate }}</p>

        @if (!store.tables.length) {
          @if (store.inspecting) {
            <div class="admin-import-module__inspect">
              <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
              @if (store.waitingForFile) {
                <span class="admin-import-module__hint">{{ 'TRANS__IMPORT__TABLE__WAITING_FOR_FILE' | translate }}</span>
              }
            </div>
          } @else if (store.inspectFailed) {
            <div class="admin-import-module__inspect">
              <button mat-stroked-button color="primary" type="button" (click)="store.inspectSource()">
                <span class="bold uppercase">{{ 'TRANS__IMPORT__TABLE__INSPECT' | translate }}</span>
              </button>
            </div>
          }
        } @else {
          <div class="admin-import-module__table-picker">
            <mat-radio-group
              class="admin-import-module__tables"
              [attr.aria-label]="'TRANS__IMPORT__TABLE_SECTION' | translate"
              [value]="store.selectedTable"
              (change)="store.selectTable($event.value)"
            >
              <div class="admin-import-module__table-row admin-import-module__table-row--head">
                <span>{{ 'TRANS__IMPORT__TABLE_SECTION' | translate }}</span>
                <span class="admin-import-module__table-count">{{ 'TRANS__IMPORT__TABLE__ROWS' | translate }}</span>
                <span class="admin-import-module__table-count">{{ 'TRANS__IMPORT__TABLE__COLUMNS' | translate }}</span>
              </div>
              @for (row of tableRows; track row.name) {
                <div
                  class="admin-import-module__table-row"
                  [class.admin-import-module__table-row--selected]="row.name === store.selectedTable"
                  [class.admin-import-module__table-row--empty]="row.empty"
                >
                  <mat-radio-button [value]="row.name" [disabled]="row.empty">
                    <span class="admin-import-module__table-label">
                      <span class="admin-import-module__table-name">{{ row.name }}</span>
                      @if (row.empty) {
                        <span class="admin-import-module__table-note">{{ 'TRANS__IMPORT__TABLE__EMPTY' | translate }}</span>
                      }
                      @if (row.name === store.selectedTable || row.largest) {
                        <span class="admin-import-module__table-note admin-import-module__table-note--primary">
                          @if (row.name === store.selectedTable) {
                            {{ 'TRANS__IMPORT__TABLE__OBJECTS' | translate }}
                          }
                          @if (row.name === store.selectedTable && row.largest) {
                            ·
                          }
                          @if (row.largest) {
                            {{ 'TRANS__IMPORT__TABLE__LARGEST' | translate }}
                          }
                        </span>
                      }
                      @for (lookupName of row.lookupNames; track $index) {
                        <span class="admin-import-module__table-note">
                          {{ 'TRANS__IMPORT__TABLE__LOOKUP_FOR' | translate: {name: lookupName} }}
                        </span>
                      }
                    </span>
                  </mat-radio-button>
                  <span class="admin-import-module__table-count">{{ row.stats ? rowCount(row.stats) : '' }}</span>
                  <span class="admin-import-module__table-count">{{ row.stats?.columns ?? '' }}</span>
                </div>
              }
            </mat-radio-group>

            @if (store.selectedTable && !store.loadingColumns && store.columns.length) {
              <div #preview class="admin-import-module__preview" id="import-source-preview">
                <p class="admin-import-module__preview-title">
                  <span class="admin-import-module__table-name">{{ store.selectedTable }}</span>
                  <span class="admin-import-module__hint">
                    @if (selectedTableStats; as stats) {
                      {{ 'TRANS__IMPORT__TABLE_PREVIEW__SUMMARY' | translate: {
                        rows: store.firstRows.length, total: rowCount(stats),
                        shown: previewColumns.length, columns: store.columns.length
                      } }}
                    } @else {
                      {{ 'TRANS__IMPORT__TABLE_PREVIEW__SUMMARY_UNCOUNTED' | translate: {
                        rows: store.firstRows.length, shown: previewColumns.length, columns: store.columns.length
                      } }}
                    }
                  </span>
                </p>
                <div class="admin-import-module__preview-scroll">
                  <table class="admin-import-module__preview-table">
                    <thead>
                      <tr>
                        @for (column of previewColumns; track column) {
                          <th scope="col">{{ column }}</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (row of store.firstRows; track row.row_id) {
                        <tr>
                          @for (column of previewColumns; track column) {
                            <td>{{ row.values[column] }}</td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
                @if (otherColumns.length) {
                  <div class="admin-import-module__other-columns">
                    <span class="admin-import-module__hint">{{ 'TRANS__IMPORT__TABLE_PREVIEW__MORE_COLUMNS' | translate }}</span>
                    @for (column of otherColumns; track column) {
                      <span class="admin-import-module__column-token">{{ column }}</span>
                    }
                  </div>
                }
              </div>
            }
            @if (store.selectedTable && !store.loadingColumns && !store.loadingTargetFields
                && (store.columnsFailed || store.targetFieldsFailed)) {
              <div class="admin-import-module__inspect admin-import-module__table-retry">
                <button mat-stroked-button color="primary" type="button" (click)="store.retrySelectedTable()">
                  <span class="bold uppercase">{{ 'TRANS__IMPORT__LOOKUPS__RETRY' | translate }}</span>
                </button>
              </div>
            }
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>

  <div class="admin-import-module__pair">
    <div class="admin-import-module__section admin-import-module__section--type" id="import-source-object-type">
      <h4>{{ 'TRANS__FIELD__OBJECT_TYPE' | translate }}</h4>
      <mat-card appearance="outlined">
        <mat-card-content>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ 'TRANS__FIELD__OBJECT_TYPE' | translate }}</mat-label>
            <mat-select [formControl]="store.objectTypeControl">
              @for (choice of store.objectTypes; track choice.object_type) {
                <mat-option [value]="choice.object_type">{{ choice.name | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (store.buildingModel) {
            <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
          }
          @if (store.batchDefaults) {
            <span class="admin-import-module__caption">{{ 'TRANS__IMPORT__BATCH_DEFAULTS__ALL_ROWS' | translate }}</span>
            <div #batchDefaults class="admin-import-module__batch-defaults">
              <app-edit-prime-fields [sectionsContainer]="store.batchDefaults"></app-edit-prime-fields>
            </div>
            @if (store.statusColumnsText; as columns) {
              <p class="admin-import-module__hint admin-import-module__status-from-column">
                {{ 'TRANS__IMPORT__BATCH_DEFAULTS__STATUS_FROM_COLUMN' | translate: {columns: columns} }}
              </p>
            }
          }
        </mat-card-content>
      </mat-card>
    </div>

    <div class="admin-import-module__section admin-import-module__section--media" id="import-source-media">
      <h4>{{ 'TRANS__IMPORT__MEDIA_SECTION' | translate }}</h4>
      <mat-card appearance="outlined">
        <mat-card-content>
          <mat-checkbox [formControl]="store.linkMediaControl" class="admin-import-module__link-media">
            {{ 'TRANS__IMPORT__LINK_MEDIA' | translate }}
          </mat-checkbox>
          <p class="admin-import-module__hint admin-import-module__link-media-hint">
            {{ 'TRANS__IMPORT__LINK_MEDIA_HINT' | translate }}
          </p>

          @if (store.linkMediaControl.value && store.selectedTable && store.columns.length) {
            <mat-form-field appearance="outline" class="admin-import-module__media-join">
              <mat-label>{{ 'TRANS__IMPORT__MEDIA_JOIN_COLUMN' | translate }}</mat-label>
              <mat-select [formControl]="store.mediaJoinColumnControl">
                <mat-option [value]="null">
                  {{ 'TRANS__IMPORT__MEDIA_JOIN_NONE' | translate }}
                </mat-option>
                @for (column of store.columns; track column.name) {
                  <mat-option [value]="column.name">{{ column.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            @if (store.mediaJoinColumnControl.value && store.mediaFolders.length) {
              <mat-form-field appearance="outline" class="admin-import-module__media-join">
                <mat-label>{{ 'TRANS__IMPORT__MEDIA_FOLDER' | translate }}</mat-label>
                <mat-select [formControl]="store.mediaFolderControl">
                  <mat-option [value]="null">
                    {{ 'TRANS__IMPORT__MEDIA_FOLDER_ANY' | translate }}
                  </mat-option>
                  @for (folder of store.mediaFolders; track folder.id) {
                    <mat-option [value]="folder.id">{{ folder.name }}</mat-option>
                  }
                </mat-select>
                <mat-hint>{{ 'TRANS__IMPORT__MEDIA_FOLDER_HINT' | translate }}</mat-hint>
              </mat-form-field>
            }

            @if (store.mediaJoinColumnControl.value) {
              <fieldset class="admin-import-module__media-choice">
                <legend>{{ 'TRANS__IMPORT__MEDIA_MATCH' | translate }}</legend>
                <mat-radio-group [formControl]="store.mediaMatchModeControl">
                  <mat-radio-button value="file_name">
                    {{ 'TRANS__IMPORT__MEDIA_MATCH_FILE_NAME' | translate }}
                  </mat-radio-button>
                  <mat-radio-button value="pattern">
                    {{ 'TRANS__IMPORT__MEDIA_MATCH_PATTERN' | translate }}
                  </mat-radio-button>
                </mat-radio-group>
                @if (store.mediaMatchModeControl.value === 'pattern') {
                  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="admin-import-module__media-preset">
                    <mat-label>{{ 'TRANS__IMPORT__MEDIA_MATCH_RULE_LABEL' | translate }}</mat-label>
                    <mat-select [formControl]="store.mediaMatchPresetControl">
                      @for (preset of store.mediaMatchPresets; track preset.id) {
                        <mat-option [value]="preset.id">{{ preset.labelKey | translate }}</mat-option>
                      }
                    </mat-select>
                    @if (store.mediaMatchPresetControl.value !== 'custom') {
                      <mat-hint class="admin-import-module__media-preset-pattern">{{ store.mediaMatchPatternControl.value }}</mat-hint>
                    }
                  </mat-form-field>
                  @if (store.mediaMatchPresetControl.value === 'custom') {
                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="admin-import-module__media-pattern">
                      <mat-label>{{ 'TRANS__IMPORT__MEDIA_MATCH_PATTERN_LABEL' | translate }}</mat-label>
                      <input matInput [formControl]="store.mediaMatchPatternControl" maxlength="200"
                             autocomplete="off" spellcheck="false">
                      <mat-hint>{{ 'TRANS__IMPORT__MEDIA_MATCH_PATTERN_HINT' | translate }}</mat-hint>
                    </mat-form-field>
                  }
                }
                <mat-checkbox [formControl]="store.mediaIgnoreLeadingZerosControl"
                              class="admin-import-module__media-zeros">
                  {{ 'TRANS__IMPORT__MEDIA_IGNORE_LEADING_ZEROS' | translate }}
                </mat-checkbox>
              </fieldset>

              <fieldset class="admin-import-module__media-choice">
                <legend>{{ 'TRANS__IMPORT__MEDIA_JOIN_SEVERAL' | translate }}</legend>
                <mat-radio-group [formControl]="store.mediaJoinSeveralControl">
                  <mat-radio-button value="skip">
                    {{ 'TRANS__IMPORT__MEDIA_JOIN_SEVERAL_SKIP' | translate }}
                  </mat-radio-button>
                  <mat-radio-button value="link_all">
                    {{ 'TRANS__IMPORT__MEDIA_JOIN_SEVERAL_LINK_ALL' | translate }}
                  </mat-radio-button>
                </mat-radio-group>
              </fieldset>

              @if (store.mediaJoinProblem; as problem) {
                <p class="admin-import-module__warn">{{ problem | translate }}</p>
              }

              <fieldset class="admin-import-module__on-missing">
                <legend>{{ 'TRANS__IMPORT__MEDIA_ON_MISSING' | translate }}</legend>
                <mat-radio-group [formControl]="store.mediaOnMissingControl">
                  <mat-radio-button value="block">
                    {{ 'TRANS__IMPORT__MEDIA_ON_MISSING_BLOCK' | translate }}
                  </mat-radio-button>
                  <mat-radio-button value="skip_row">
                    {{ 'TRANS__IMPORT__MEDIA_ON_MISSING_SKIP' | translate }}
                  </mat-radio-button>
                  <mat-radio-button value="create_without_media">
                    {{ 'TRANS__IMPORT__MEDIA_ON_MISSING_CREATE' | translate }}
                  </mat-radio-button>
                </mat-radio-group>
              </fieldset>
            }
          }
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
